/**
 * ArloAttributionCaption.js - "Powered by Arlo" attribution block.
 *
 * Compliance surface shared by the rail title row, chat footer, and PDP
 * similar rail: copy/logo/link always come from the attribution payload,
 * never hardcoded. Callers gate rendering on payload.required and report
 * attributionRendered() themselves. logo_url currently points at an
 * unresolvable host (cdn.arlotv.ai), so a load failure degrades to text
 * instead of a broken-image box.
 */
import React, { useState } from 'react';

const ArloAttributionCaption = ({ attribution }) => {
  const [logoFailed, setLogoFailed] = useState(false);

  const body = (
    <>
      {attribution.logo_url && !logoFailed && (
        <img
          src={attribution.logo_url}
          alt=""
          className="inline-block h-4 mr-1 align-text-bottom"
          onError={() => setLogoFailed(true)}
        />
      )}
      {attribution.text || 'Powered by Arlo'}
    </>
  );

  return attribution.link ? (
    <a
      href={attribution.link}
      target="_blank"
      rel="noopener noreferrer"
      className="text-sm text-white/50 hover:text-white/80"
    >
      {body}
    </a>
  ) : (
    <span className="text-sm text-white/50">{body}</span>
  );
};

export default ArloAttributionCaption;
